function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import isObjectLike from 'lodash/isObjectLike';
var _React_PureComponent;
class Information extends (_React_PureComponent = React.PureComponent) {
    renderLabel() {
        if (!this.props.labelMessage) {
            return null;
        }
        return /*#__PURE__*/ _jsx("label", {
            className: "form-label",
            children: isObjectLike(this.props.labelMessage) ? /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, this.props.labelMessage)) : this.props.labelMessage
        });
    }
    renderValue() {
        return /*#__PURE__*/ _jsx("div", {
            className: "row align-items-center justify-content-between",
            children: /*#__PURE__*/ _jsx("div", {
                className: "col",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "input-container",
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "form-control form-control--static-text",
                        children: this.props.value
                    })
                })
            })
        });
    }
    render() {
        return /*#__PURE__*/ _jsxs("div", {
            className: "form-group row no-gutters form-group--one-liner",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "col-3",
                    children: this.renderLabel()
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "col-6",
                    children: this.renderValue()
                })
            ]
        });
    }
}
_define_property(Information, "propTypes", {
    labelMessage: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    value: PropTypes.node
});
export default Information;
